import { RenovationType } from '../types/Hotel';
import type { RawHotel } from '../types/RawHotel';

const getRenovationTypes = (hotel: Pick<RawHotel, 'builtDate' | 'renovationDate'>): RenovationType[] => {
    if (!hotel.builtDate && !hotel.renovationDate) return [];
    const currentYear = new Date().getFullYear();
    const reuslt = [];

    if (hotel.builtDate && currentYear - hotel.builtDate <= 5) {
        reuslt.push(RenovationType.RecentlyOpened);
    }

    if (hotel.renovationDate && currentYear - hotel.renovationDate <= 5) {
        reuslt.push(RenovationType.FreshRenovation);
    }

    return reuslt;
};

export default getRenovationTypes;
